module.exports = function() {
  return new Worker("/" + "typescript-transpiler.4b75310a.worker.js");
};